// extracted by mini-css-extract-plugin
export default {"services_wrapper":"KeyServices_services_wrapper__MhBVW","services_grid":"KeyServices_services_grid__7tE9m"};